import * as React from 'react';
import Box from '@mui/material/Box';

import HoneyfundFrame from 'components/Registry/HoneyfundFrame.tsx';
import WeddingAppBar from 'components/AppBar.tsx';

 export default function Honeyfund() {
  return (
    <Box sx={{
      height: "100vh",
      width: "100vw",
      bgcolor: "white",
    }}>
      <WeddingAppBar />
      <HoneyfundFrame />
    </Box>
  );
}
